exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vertical {\n  border-left: 1px solid #dddddd;\n  height: 280px;\n  position:absolute;\n}\n.valida-letras{\n  text-transform: uppercase;\n}\n.uppercase-text{\n  text-transform: uppercase;\n}\n", ""]);

// exports
